<template>
  <div class="pb-8 pl-0 pr-0 ml-0" :class="{ 'mobile-responsive': isMobile }">
    <the-header :logo="require('@/assets/img/ciie.png')" :logout="logout" />
    <the-navigation-bar v-if="false" />
    <the-sitemap />
    <div class="case-layout">
      <div
        :class="{
          'case-layout__content': !canViewActionSideBar,
          'case-layout__content-sidebar': isEditMode && canViewActionSideBar,
        }"
      >
        <main :key="rightLayoutKey" class="page-content">
          <router-view></router-view>
        </main>
      </div>
    </div>
    <window-resize />
    <screenshot-selection ref="screenshotSelectionRef" />
    <floating-button style="left: 168px; bottom: 15px">
      <action-button
        class="warning px-3 py-2"
        i="fa fa-exclamation-circle"
        :text="$t('Feedbacklabel')"
        @click="onOpenIncidentReportModal"
      />
    </floating-button>

    <!--Incident Report Modal-->
    <incident-report-modal
      ref="myIncidentReportModal"
      @close="onCloseIncidentReportModal"
      @accept="onOpenIncidentReportModal"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';

//components
import TheHeader from './TheHeader';
import WindowResize from './WindowResize.vue';
import TheNavigationBar from './TheNavigationBar.vue';
import TheSitemap from './TheSitemap.vue';
import { IncidentReportModal } from '@/components/layout/components';
import { FloatingButton } from '@/components/common';
import ActionButton from 'ActionButton';

//stores
import { name as userModuleName } from '@/store/modules/user';
import { name as appModuleName } from '@/store/modules/app';

//i18n
import { loadLanguageAsync } from '@/i18n';
import { ScreenshotSelection } from '@/components/layout/components';

export default {
  name: 'MainLayout',
  components: {
    ScreenshotSelection,
    TheHeader,
    WindowResize,
    TheNavigationBar,
    TheSitemap,
    ActionButton,
    IncidentReportModal,
    FloatingButton,
  },
  data() {
    return {
      rightLayoutKey: 0,
      windowWidth: 0,
      catalog: {
        applications: [],
        modules: [],
        itemReceiptMediaTypes: [],
        referenceCategories: [],
        itemSubTypes: [],
        documentCategories: [],
        technicalUsers: [],
        itemStatuses: [],
      },
    };
  },
  provide() {
    return {
      ...this.catalog,
    };
  },
  computed: {
    ...mapGetters(appModuleName, {
      isMobile: 'getIsMobileDensity',
      isNavOpened: 'getIsNavOpen',
      assignedRequests: 'getAssignedRequests',
    }),
    ...mapState(appModuleName, ['isCaseListOpen']),
    showCaseList() {
      if (this.isMobile) {
        return this.isCaseListOpen;
      } else {
        return true;
      }
    },
  },
  async mounted() {
    window.location.hash = '';
  },
  async created() {
    await loadLanguageAsync();
  },
  methods: {
    ...mapActions(userModuleName, ['logout']),
    setPushElements(key, values) {
      if (values != null) {
        this.setPopElements(key, values);

        for (const el of values) {
          this.catalog[key].push(el);
        }
      }
    },
    setPopElements(key, values) {
      for (const el of values) {
        this.catalog[key].pop(el);
      }
    },
    refreshLayoutHandler() {
      this.rightLayoutKey += 1;
    },
    onOpenIncidentReportModal() {
      if (this.$refs.myIncidentReportModal) {
        this.$refs.myIncidentReportModal.showModal();
      }
    },
    onCloseIncidentReportModal() {
      this.$refs.myIncidentReportModal?.hideModal();
    },
  },
};
</script>

<style scope lang="scss">
.case-layout {
  &__list {
    min-width: 132px;
    max-width: 132px;
  }
  &__content {
    width: 100%;
  }
  &__content-sidebar {
    width: 97%;
  }
}
.pb-8 {
  margin-bottom: 5rem !important;
}
</style>
